import script from "./TablaClasificacionElo.vue?vue&type=script&setup=true&lang=ts"
export * from "./TablaClasificacionElo.vue?vue&type=script&setup=true&lang=ts"

import "./TablaClasificacionElo.vue?vue&type=style&index=0&id=6541ae72&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6541ae72"]])

export default __exports__